/* eslint-disable import/no-unresolved */
import {BrowserAgent} from '@newrelic/browser-agent/loaders/browser-agent';
import {PageViewEvent} from '@newrelic/browser-agent/features/page_view_event';
import {PageViewTiming} from '@newrelic/browser-agent/features/page_view_timing';
/* eslint-enable import/no-unresolved */

/**
 * Simple singleton to load the NR browser agent.
 *
 * @link https://docs.newrelic.com/docs/browser/browser-monitoring/installation/install-browser-monitoring-agent/
 */
class NewRelicBrowser {
  static instance = null;

  static load() {
    if (NewRelicBrowser.instance) {
      return NewRelicBrowser.instance;
    }

    const licenseKey = process.env.NEW_RELIC_LICENSE_KEY;

    if (!licenseKey) {
      return null;
    }

    NewRelicBrowser.instance = new BrowserAgent({
      init: {
        distributed_tracing: {enabled: true},
        privacy: {cookies_enabled: true},
        ajax: {deny_list: ['bam.nr-data.net']},
      },
      info: {
        beacon: 'bam.nr-data.net',
        errorBeacon: 'bam.nr-data.net',
        licenseKey,
        applicationID: process.env.NEW_RELIC_APP_ID,
        sa: 1,
      },
      loader_config: {
        accountID: process.env.NEW_RELIC_ACCOUNT_ID,
        trustKey: process.env.NEW_RELIC_TRUST_KEY,
        agentID: process.env.NEW_RELIC_APP_ID,
        licenseKey,
        applicationID: process.env.NEW_RELIC_APP_ID,
      },
      features: [PageViewEvent, PageViewTiming],
    });

    return NewRelicBrowser.instance;
  }
}

NewRelicBrowser.load();

export default NewRelicBrowser;
